<div class="footerCommon bg-marty-green">
  <div class="footerCommon__row">
    <!-- Links -->
    <div class="footerCommon__col footerCommon__copyright">
      <!-- <ng-container *ngFor="let link of links">
        <span class="footer_link {{ link.classes }}">
          {{ link.preText }}
          <a (click)="window.open(link.page, link.target, link.options)">
            {{ link.label }}
          </a>
          {{ link.postText }}
          <span class="footer_linkSeparator"> | </span>
        </span>
      </ng-container> -->
    </div>

    <!-- Company Info -->
    <div class="footerCommon__col footerCommon__margin footerCommon_companyInfo">
      <div class="footerCommon__row">
        <div class="footerCommon__col footerCommon__logo">
          <img src="{{ brandLogo }}">
        </div>
        <div class="footerCommon__col footerCommon__contact">
          <p>{{ phoneNumber }} | <b>{{ footerEmail }}</b></p>
          <p>{{ address }}</p>
        </div>
      </div>
    </div>

    <!-- Top Section with Disclaimer and Texts -->
    <div class="footerCommon__col footerCommon__top">
      <div class="footerCommon__row">
        <div class="footerCommon__col footerDisclaimer" *ngIf="footerDisclaimer">
          <p [innerHTML]="footerDisclaimerText"></p>
        </div>
        <div class="footerCommon__col" *ngIf="swapFormat">
          <p [innerHTML]="copyrightText"></p>
        </div>
        <div class="footerCommon__col">
          <p>{{ mainText }}</p>
        </div>
      </div>
    </div>

    <!-- Final Row Text -->
    <div class="footerCommon__col footerCommon__top footerCommon_rowText">
      <p [innerHTML]="copyrightText"></p>
    </div>
  </div>
</div>

